<div class="mb-5">
  <div class="row m-0 text-center">
    <div class="corsi-background corsi-container">
      <h2 class="blue-50 bold">Un mondo di corsi per mettersi in gioco.</h2>
      <h3 class="neutral-90 mt-3 p-4 p-xl-0">
        L’offerta formativa di Easycode prevede diversi livelli e tecnologie, a
        seconda dell’età degli studenti. Perchè in Easycode è importante
        imparare divertendosi.
      </h3>

      <div class="container-filters">
        <label for="search-courses" class="visually-hidden">Cerca corsi</label>
        <input
          id="search-courses"
          type="text"
          value=""
          class="search-courses"
          placeholder="Cerca corsi"
          autocomplete="off"
          (keyup)="filterName($event)"
        />

        <!--display desktop-->
        <section class="d-none d-lg-block">
          <div class="button-filter">
            <button
              class="btn-f w-700"
              (click)="filter('T')"
              [ngClass]="activeFilter == 'T' ? 'active' : ''"
            >
              Tutti i corsi
            </button>

            <button
              class="btn-f w-700 d-none d-xl-inline"
              (click)="filter('E')"
              [ngClass]="activeFilter == 'E' ? 'active' : ''"
            >
              Primaria
            </button>
            <button
              class="btn-f w-700 d-none d-xl-inline"
              (click)="filter('M')"
              [ngClass]="activeFilter == 'M' ? 'active' : ''"
            >
              Secondaria I grado
            </button>
            <button
              class="btn-f w-700"
              (click)="filter('S')"
              [ngClass]="activeFilter == 'S' ? 'active' : ''"
            >
              Secondaria II grado
            </button>
          </div>
        </section>
        <!--display mobile-->
        <section class="d-md-flex d-lg-none container-filters-sm">
          <div class="button-filter">
            <button
              class="btn-f w-700"
              (click)="filter('T')"
              [ngClass]="activeFilter == 'T' ? 'active' : ''"
            >
              Tutti i corsi
            </button>

            <button
              class="btn-f w-700 d-xl-inline"
              (click)="filter('E')"
              [ngClass]="activeFilter == 'E' ? 'active' : ''"
            >
              Primaria
            </button>
          </div>
          <div
            class="button-filter"
            style="margin-top: 0px; margin-bottom: 0px;"
          >
            <button
              class="btn-f w-100 d-xl-inline"
              (click)="filter('M')"
              [ngClass]="activeFilter == 'M' ? 'active' : ''"
            >
              Secondaria I grado
            </button>
          </div>
          <div
            class="button-filter"
            style="margin-top: 0px; width: 100%"
          >
            <button
              class="btn-f w-100 "
              (click)="filter('S')"
              [ngClass]="activeFilter == 'S' ? 'active' : ''"
            >
              Secondaria II grado
            </button>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="row p-0 m-0 mb-5">
  <div class="col-1"></div>
  <div
    class="row col-10 p-0 m-0 courses-list"
    style="gap: 30px; display: inline-flex"
  >
    <div
      class="course-card mb-4"
      *ngFor="let course of filteredList"
      style="margin: auto"
    >
      <img
        [src]="course.img"
        class="course-img"
        alt="Un mondo di corsi per mettersi in gioco"
       
      />

      <div class="course-txt p-3">
        <h3 class="blue-60 w-700 course-ttl">{{ course.name }}</h3>
        <span class="course-desc">{{ course.text }}</span>
        <button class="course-link mt-5" (click)="openCourse(course)" [attr.aria-label]="'Scopri il corso ' + course.name"><span class="visually-hidden">Scopri il corso {{ course.name }}</span></button>
      </div>
    </div>
  </div>
  <div class="col-1"></div>
</div>

<app-iscriviti></app-iscriviti>
